<template>
  <div class="bg-green py-2 px-4 rounded-lg shadow-lg cursor-pointer transition-all">
    <h1>{{ notification.title }}</h1>
    <span class="text-sm mt-2">{{ notification.body }}</span>
  </div>
</template>

<script>
export default {
  name: "VNotification",
  props: ['notification']
}
</script>

<style scoped>

</style>